import { defineMessages } from "react-intl";

import { node as hbv } from "src/modules/ktx/forms/transplantation-screening/medical-history/chronic-liver-failure/chronicLiverFailureHbv";
import { node as hcv } from "src/modules/ktx/forms/transplantation-screening/medical-history/chronic-liver-failure/chronicLiverFailureHcv";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.chronic_liver_failure",
		defaultMessage: "Krónikus májelégtelenség"
	}
});

export const node: ParentNode = {
	id: "ktx-chronic-liver-failure",
	value: { type: "wizard", title: messages.title },
	children: [hbv, hcv]
};
